import { Typography } from '@mui/material';
import { useUserInfo } from '@xolv-mybrightlink/common';
import { FormattedMessage } from 'react-intl';

export const WelcomeBack = () => {
  const currentUser = useUserInfo();
  return (
    <Typography color='text.primary' fontWeight={500} fontSize={24}>
      <FormattedMessage
        id='welcome-back'
        values={{ name: currentUser.first_name }}
      />
    </Typography>
  );
};
